var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isObject = require('../help/is_object');

var validateCrit = require('../help/validate_crit');

var _require = require('../errors'),
    JWEInvalid = _require.JWEInvalid;

validateCrit = validateCrit.bind(undefined, JWEInvalid);

var compactSerializer = function compactSerializer(final, _ref) {
  var _ref2 = _slicedToArray(_ref, 1),
      recipient = _ref2[0];

  return "".concat(final.protected, ".").concat(recipient.encrypted_key, ".").concat(final.iv, ".").concat(final.ciphertext, ".").concat(final.tag);
};

compactSerializer.validate = function (protectedHeader, unprotectedHeader, aad, _ref3) {
  var header = _ref3[0].header,
      length = _ref3.length;

  if (length !== 1 || aad || unprotectedHeader || header) {
    throw new JWEInvalid('JWE Compact Serialization doesn\'t support multiple recipients, JWE unprotected headers or AAD');
  }

  validateCrit(protectedHeader, unprotectedHeader, protectedHeader ? protectedHeader.crit : undefined);
};

var flattenedSerializer = function flattenedSerializer(final, _ref4) {
  var _ref5 = _slicedToArray(_ref4, 1),
      recipient = _ref5[0];

  var header = recipient.header,
      encryptedKey = recipient.encrypted_key;
  return _objectSpread({}, final.protected ? {
    protected: final.protected
  } : undefined, {}, final.unprotected ? {
    unprotected: final.unprotected
  } : undefined, {}, header ? {
    header: header
  } : undefined, {}, encryptedKey ? {
    encrypted_key: encryptedKey
  } : undefined, {}, final.aad ? {
    aad: final.aad
  } : undefined, {
    iv: final.iv,
    ciphertext: final.ciphertext,
    tag: final.tag
  });
};

flattenedSerializer.validate = function (protectedHeader, unprotectedHeader, aad, _ref6) {
  var header = _ref6[0].header,
      length = _ref6.length;

  if (length !== 1) {
    throw new JWEInvalid('Flattened JWE JSON Serialization doesn\'t support multiple recipients');
  }

  validateCrit(protectedHeader, _objectSpread({}, unprotectedHeader, {}, header), protectedHeader ? protectedHeader.crit : undefined);
};

var generalSerializer = function generalSerializer(final, recipients) {
  var result = _objectSpread({}, final.protected ? {
    protected: final.protected
  } : undefined, {}, final.unprotected ? {
    unprotected: final.unprotected
  } : undefined, {
    recipients: recipients.map(function (_ref7) {
      var header = _ref7.header,
          encryptedKey = _ref7.encrypted_key,
          generatedHeader = _ref7.generatedHeader;

      if (!header && !encryptedKey && !generatedHeader) {
        return false;
      }

      return _objectSpread({}, header || generatedHeader ? {
        header: _objectSpread({}, header, {}, generatedHeader)
      } : undefined, {}, encryptedKey ? {
        encrypted_key: encryptedKey
      } : undefined);
    }).filter(Boolean)
  }, final.aad ? {
    aad: final.aad
  } : undefined, {
    iv: final.iv,
    ciphertext: final.ciphertext,
    tag: final.tag
  });

  if (!result.recipients.length) {
    delete result.recipients;
  }

  return result;
};

generalSerializer.validate = function (protectedHeader, unprotectedHeader, aad, recipients) {
  recipients.forEach(function (_ref8) {
    var header = _ref8.header;
    validateCrit(protectedHeader, _objectSpread({}, header, {}, unprotectedHeader), protectedHeader ? protectedHeader.crit : undefined);
  });
};

var isJSON = function isJSON(input) {
  return isObject(input) && typeof input.ciphertext === 'string' && typeof input.iv === 'string' && typeof input.tag === 'string' && (input.unprotected === undefined || isObject(input.unprotected)) && (input.protected === undefined || typeof input.protected === 'string') && (input.aad === undefined || typeof input.aad === 'string');
};

var isSingleRecipient = function isSingleRecipient(input) {
  return (input.encrypted_key === undefined || typeof input.encrypted_key === 'string') && (input.header === undefined || isObject(input.header));
};

var isValidRecipient = function isValidRecipient(recipient) {
  return isObject(recipient) && typeof recipient.encrypted_key === 'string' && (recipient.header === undefined || isObject(recipient.header));
};

var isMultiRecipient = function isMultiRecipient(input) {
  if (Array.isArray(input.recipients) && input.recipients.every(isValidRecipient)) {
    return true;
  }

  return false;
};

var detect = function detect(input) {
  if (typeof input === 'string' && input.split('.').length === 5) {
    return 'compact';
  }

  if (isJSON(input)) {
    if (isMultiRecipient(input)) {
      return 'general';
    }

    if (isSingleRecipient(input)) {
      return 'flattened';
    }
  }

  throw new JWEInvalid('JWE malformed or invalid serialization');
};

module.exports = {
  compact: compactSerializer,
  flattened: flattenedSerializer,
  general: generalSerializer,
  detect: detect
};